    // 复制优惠码 
    document.addEventListener('DOMContentLoaded', () => {
        $(".product-list li .code-wrapper .copy-code, .ann-8th-code-wrapper .copy-code").click(function () {
            navigator.clipboard.writeText($(this).siblings(".code-content").text().trim());
            $(this).html('<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9L6.62319 13.5714L13 3.57141" stroke="#C21F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            setTimeout(() => {
              $(this).html("COPY");
            }, 3000);
          });
       
      }); 
